/**
 * External Booking Reference flight categories
 *
 * Represents the different types of flights that can be booked:
 * - Mission: Organ transport flights with UNOS ID and organ type
 * - Maintenance: Aircraft maintenance flights (prefix: MX)
 * - Training: Training and certification flights (prefix: TRNG)
 * - Reposition: Fleet repositioning flights (prefix: Repo)
 * - Special: Special operations flights (prefix: Special)
 * - Unknown: Could not determine category or legacy format
 */
export enum EExternalReferenceCategory {
  Mission = 'Mission',
  Maintenance = 'Maintenance',
  Training = 'Training',
  Reposition = 'Reposition',
  Special = 'Special',
  Unknown = 'Unknown',
}
